/* src/app/modules/advisor/advisor-dialog-delete.component.css */
/*# sourceMappingURL=advisor-dialog-delete.component.css.map */
